<template>
    <div class="main">
        <c-panel title="GRUPOS DE CONCEITO" titleIcon="fas fa-list">
            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="16" :md="16">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar grupo de conceito..." @keyup.native.enter="load"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                    <router-link to="/admin/grupo-conceito/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO GRUPO DE CONCEITO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th>Nome</th>
                            <th class="hidden-mobile">Descrição</th>
                            <th class="hidden-mobile u-text-center" style="width: 110px;">Situação</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td class="u-uppercase">{{ item.nome | truncate(40, '...') }}</td>
                            <td class="hidden-mobile">{{ item.descricao || '—' }}</td>
                            <td class="hidden-mobile u-text-center" style="text-transform: uppercase;">{{ item.situacao === false ? 'Inativo' : 'Ativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/grupo-conceito/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="5" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum registro encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="getPage" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: { nome: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: []
    }),
    mounted () { this.load() },
    methods: {
        load () {
            this.statusList = false
            this.items = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/grupo-conceito/getAllPaginate?page=${this.paginate.page}`,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este registro?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/grupo-conceito/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        getPage (page) {
            this.paginate.page = page
            this.load()
        }
    }
}
</script>
